import Vue from 'vue'
import Vuex from 'vuex'
import Auth from '@/services/auth'
import User from '@/services/users'
import Organization from '@/services/organizations'
import Employee from '@/services/employees'
import actions from '@/store/actions'

Vue.use(Vuex)

const STORAGE_HASH = 'adf238fna'
export const STORAGE_KEY = `canary-${STORAGE_HASH}`

const state = {
  user: null,
  token: window.localStorage.getItem('token'),
  // This should mirror and be kept in sync with this.$language.current
  // and the current user's language preference as saved in the DB
  currentLanguage: 'en_US',
  // This default organization is intended to be a suitable fallback for
  // testing purposes and staff users, who may not have an organization
  // and subdomain.
  organizationDetails: Organization.create({
    name: 'Your Organization',
  }),
  organizationCssVars: null,
  currentRequest: JSON.parse(window.localStorage.getItem('currentRequest')),
  currentDonation: JSON.parse(window.localStorage.getItem('currentDonation')),
  currentAnonymousDonor: JSON.parse(window.localStorage.getItem('currentAnonymousDonor')),
  currentPayrollRequest: JSON.parse(window.localStorage.getItem('currentPayrollRequest')),
  requestHasUncommonExpenseCategories: null,
  requestHasCommonExpenseCategories: null,
}

const mutations = {
  updateEvent(state, payload) {
    const requestEventIndex = state.currentRequest.eventsRef.findIndex(
      event => event.id == payload.eventRef.id,
    )
    state.currentRequest.eventsRef.splice(requestEventIndex, 1, payload.eventRef)
  },
  updateUncommonExpenseCheck(state, payload) {
    state.requestHasUncommonExpenseCategories = payload
  },
  updateCommonExpenseCheck(state, payload) {
    state.requestHasCommonExpenseCategories = payload
  },
  UPDATE_ORG: (state, payload) => {
    state.organizationDetails = payload
  },
  UPDATE_USER: (state, payload) => {
    state.user = payload
  },
  UPDATE_USERTOKEN: (state, payload) => {
    state.token = payload
    if ((payload && typeof payload === 'string') || payload instanceof String) {
      window.localStorage.setItem('token', payload)
      return
    }
  },
  UPDATE_CURRENT_LANGUAGE(state, value) {
    // Need to keep the vm.$language in sync
    if (this.$language) {
      this.$language.current = value
    }
    state.currentLanguage = value
  },
  // Reset state to defaults
  RESET_STATE(state) {
    state.token = null
    state.user = null
    state.currentRequest = null
    state.currentDonation = null
    state.currentAnonymousDonor = null
    state.currentPayrollRequest = null
    window.localStorage.clear('token')
    window.localStorage.clear('currentRequest')
    window.localStorage.clear('currentDonation')
    window.localStorage.clear('currentAnonymousDonor')
    window.localStorage.clear('currentPayrollRequest')
  },
  UPDATE_CURRENT_REQUEST: (state, payload) => {
    state.currentRequest = payload
    window.localStorage.setItem('currentRequest', JSON.stringify(payload))
  },
  UPDATE_CURRENT_DONATION: (state, payload) => {
    state.currentDonation = payload
    window.localStorage.setItem('currentDonation', JSON.stringify(payload))
  },
  CLEAR_CURRENT_DONATION(state) {
    state.currentDonation = null
    window.localStorage.clear('currentDonation')
  },
  UPDATE_CURRENT_ANONYMOUS_DONOR: (state, payload) => {
    state.currentAnonymousDonor = payload
    window.localStorage.setItem('currentAnonymousDonor', JSON.stringify(payload))
  },
  CLEAR_CURRENT_ANONYMOUS_DONOR(state) {
    state.currentAnonymousDonor = null
    window.localStorage.clear('currentAnonymousDonor')
  },
  UPDATE_CURRENT_PAYROLL_REQUEST: (state, payload) => {
    state.currentPayrollRequest = payload
    window.localStorage.setItem('currentPayrollRequest', JSON.stringify(payload))
  },
  CLEAR_CURRENT_PAYROLL_REQUEST(state) {
    state.currentPayrollRequest = null
    window.localStorage.clear('currentPayrollRequest')
  },
}

const plugins = []

const getters = {
  userIsLoggedIn: state => {
    if (state.token && !state.user) {
      //attempt to reset the user if we have a token
    }
    return state.token && state.user
  },
  organizationCssVars: (state) => ({
    '--dark-brand-color': `#${state.organizationDetails.darkBrandColor}`,
    '--light-brand-color': `#${state.organizationDetails.lightBrandColor}`,

    // Employees can only see a mobile view
    // Admin and staff users see a desktop view
    '--maximum-width': state.user && (state.user.isAdmin || state.user.isStaff) ? '100%' : '500px',
  }),
  getEventFromRequest: (state, eventId) => {
    return state.currentRequest.eventsRef.find(event => event.id == eventId)
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins,
})
